import { PRD3011_R01DetailDto } from './Dto_PRD3011_R01';

const getDetailGroupKey = (item: Pick<PRD3011_R01DetailDto, 'warehouseCd' | 'childItemcd'>) =>
	`${item.warehouseCd ?? ''}::${item.childItemcd ?? ''}`;

/**
 * getPRD3011_R01DetailList 등 LOT 단위 응답을
 * 출고창고(warehouseCd) + 자재코드(childItemcd) 기준으로 취합한다.
 */
export const aggregatePRD3011_R01DetailList = (
	detailList: PRD3011_R01DetailDto[],
): PRD3011_R01DetailDto[] => {
	const groupMap = new Map<string, PRD3011_R01DetailDto[]>();

	detailList.forEach((item) => {
		const key = getDetailGroupKey(item);
		const group = groupMap.get(key) ?? [];
		group.push(item);
		groupMap.set(key, group);
	});

	return Array.from(groupMap.values()).map((group, idx) => {
		const first = group[0];
		const totalLotQty = group.reduce((sum, item) => sum + (Number(item.lotQty) || 0), 0);
		const lotNos = group
			.map((item) => item.lotNo)
			.filter((lotNo): lotNo is string => !!lotNo);

		return {
			...first,
			valueIndex: idx + 1,
			orderIndex: idx + 1,
			orderIndexSeq: 0,
			lotQty: totalLotQty,
			lotNo: lotNos.length > 1 ? `${lotNos.length}건` : (lotNos[0] ?? ''),
			transportQty: 0,
			transportedQty: 0,
			inserted: false,
			isModified: false,
		};
	});
};

export const findAggregatedDetailItem = (
	list: PRD3011_R01DetailDto[],
	target: Pick<PRD3011_R01DetailDto, 'warehouseCd' | 'childItemcd'>,
) => list.find((item) => getDetailGroupKey(item) === getDetailGroupKey(target));
